import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';

export function EmptyState({ 
  icon: Icon,
  title,
  message,
  actionLabel,
  onActionClick,
  className = ""
}) {
  return (
    <Card className={className}>
      <CardContent className="p-12 text-center">
        {Icon && (
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-slate-100 dark:bg-slate-800 p-4">
              <Icon className="h-8 w-8 text-slate-400" />
            </div>
          </div>
        )}
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
          {title}
        </h3>
        {message && (
          <p className="text-sm text-slate-600 dark:text-slate-400 mb-6 max-w-md mx-auto">
            {message}
          </p>
        )}
        {actionLabel && onActionClick && (
          <Button onClick={onActionClick} data-testid="empty-state-action">
            <Plus className="h-4 w-4 mr-2" />
            {actionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
